"use client";

import { useState } from "react";
import type { CartItem, CartProduct } from "@/lib/cart";
import { trackEvent } from "@/components/analytics-tracker";
import { CART_STORAGE_KEY, cartItemKey } from "@/lib/cart";

export function AddToCartButton({ product, quantity = 1, className, disabled = false, disabledMessage = "Select required options" }: { product: CartProduct; quantity?: number; className?: string; disabled?: boolean; disabledMessage?: string }) {
  const [added, setAdded] = useState(false);

  function addToCart() {
    const existing = window.localStorage.getItem(CART_STORAGE_KEY);
    const items = existing ? (JSON.parse(existing) as CartItem[]) : [];
    if (disabled) return;
    const productKey = cartItemKey(product);
    const current = items.find((item) => cartItemKey(item) === productKey);

    const next = current
      ? items.map((item) => cartItemKey(item) === productKey ? { ...item, quantity: item.quantity + quantity } : item)
      : [...items, { ...product, quantity }];

    window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("abv-cart-updated"));
    trackEvent("add_to_cart", { product: product.slug, variant: product.variantSku ?? null, quantity });
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1600);
  }

  return <button type="button" onClick={addToCart} disabled={disabled} title={disabled ? disabledMessage : undefined} className={className}>{disabled ? disabledMessage : added ? "Added" : "Add to Cart"}</button>;
}

